import * as PIXI from 'pixi.js';

const WIDTH: number = 20;
const HEIGHT: number = 25;
const GRAVITY: number = 0.4;

class Particle extends PIXI.Container {
  sprite: PIXI.AnimatedSprite;
  velocity: { x: number; y: number };
  gravity: number;
  life: number;
  active: boolean;

  constructor(texture: PIXI.Texture[]) {
    super();
    this.sprite = new PIXI.AnimatedSprite(texture);
    this.addChild(this.sprite);
    this.sprite.anchor.set(0.5);
    this.sprite.animationSpeed = 0.5;
    this.velocity = { x: 0, y: 0 };
    this.gravity = GRAVITY;
    this.life = 0;
    this.active = false;
    this.visible = false; // 🔹 Hides the particle until it's initialized
  }

  init(x: number, y: number, velocityX: number, velocityY: number, life: number) {
    this.position.set(x + Math.random() * 400 - 200, y);
    this.velocity.x = velocityX;
    this.velocity.y = velocityY;
    this.sprite.scale.set(0.5 + Math.random() * 0.5);
    this.life = life;
    this.active = true;
    this.sprite.gotoAndPlay(Math.round(Math.random() * (this.sprite.totalFrames - 1)));
    this.visible = true;
  }

  update(delta: number) {
    if (!this.active) return;

    this.velocity.y += this.gravity * delta;
    this.x += this.velocity.x * delta;
    this.y += this.velocity.y * delta;
    this.angle += 1 * delta;

    this.life--;
    if (this.life <= 0) {
      this.active = false;
      this.sprite.stop();
      this.visible = false;
    }
  }
}

class ParticleSystem extends PIXI.Container {
  particles: Particle[];
  texture: PIXI.Texture[];
  emitting: boolean = false;
  intervalId?: number;

  constructor(texture: PIXI.Texture[], maxParticles: number) {
    super();
    this.texture = texture;
    this.particles = Array.from({ length: maxParticles }, () => new Particle(texture));
    this.particles.forEach(p => this.addChild(p));

    // Add update function to Pixi's ticker
    PIXI.Ticker.shared.add(this.update, this);
  }

  private emitParticle(x: number, y: number, velocityX: number, velocityY: number, life: number) {
    const particle = this.particles.find(p => !p.active);
    if (particle) {
      particle.init(x, y, velocityX, velocityY, life);
    }
  }

  start(x: number, y: number, interval: number = 100) {
    if (this.emitting) return;
    this.emitting = true;
    this.intervalId = window.setInterval(() => {
      this.emitParticle(x, y, Math.random() * WIDTH - WIDTH / 2, -Math.random() * HEIGHT, 300);
    }, interval);
  }

  stop() {
    if (this.intervalId !== undefined) {
      clearInterval(this.intervalId);
      this.intervalId = undefined;
      this.emitting = false;
    }
  }

  private update = (ticker: PIXI.Ticker) => {
    this.particles.forEach(p => p.update(ticker.deltaTime));
  };

  destroy() {
    PIXI.Ticker.shared.remove(this.update, this);
    super.destroy();
  }
}


export { ParticleSystem };
